import { Dispatch } from 'react';
import { TServiceClientActionTypes } from '../types';
import { SET_LOADING } from 'src/contexts/types';
import { handleError } from 'src/contexts/utils/handleError';
import { GET_SERVICE_CLIENT } from '../constants/actions';
import { HEADERS } from 'src/constants/headers';
import { ApiV2 } from 'src/api/apiv2';

export const getServiceClientById = async (
    dispatch: Dispatch<TServiceClientActionTypes>,
    serviceClientId: string
) => {
    dispatch({ type: SET_LOADING });

    try {
        const res = await ApiV2.post(
            `/service-clients/${serviceClientId}/read`,
            {},
            HEADERS({
                isReadPermissionNecessary: true,
            })
        );

        dispatch({
            type: GET_SERVICE_CLIENT,
            payload: res.data.data,
        });
    } catch (error) {
        if (error instanceof Error) dispatch(handleError(error));
    }
};
